import { Link } from "react-router-dom";

export default function UserProfileDropdown({ user, onClose, handleLogout }) {
  // const handleLogout = () => {
  //   localStorage.removeItem("token")
  //   localStorage.removeItem("userRole")
  //   onClose()
  //   window.location.href = "/login"
  // }

  return (
    <div className="absolute right-0 mt-2 w-72 bg-white border border-gray-200 rounded-md shadow-lg z-50">
      <div className="p-4 border-b border-gray-200 flex items-center text-left">
        <div className="w-10 h-10 flex-shrink-0 rounded-full overflow-hidden bg-gray-200 mr-3 flex items-center justify-center">
          {user?.image_url ? (
            <img
              src={`${process.env.REACT_APP_IMAGE_BASE_URL}${user.image_url}`}
              alt="User avatar"
              className="w-full h-full object-cover object-center rounded-full block"
            />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
          )}
        </div>
        <div className="min-w-0 flex-1 space-y-1">
          <div className="font-medium text-gray-900 max-h-[40px]  break-words whitespace-normal">
            {user?.first_name} {user?.last_name}
          </div>
          {/* Long emails wrap after the "@" (not mid-word); break-words only splits a
              part that can't fit on a line by itself. */}
          <div className="text-sm text-gray-500 break-words whitespace-normal" title={user?.email}>
            {user?.email?.includes("@") ? (
              <>
                {user.email.slice(0, user.email.indexOf("@") + 1)}
                <wbr />
                {user.email.slice(user.email.indexOf("@") + 1)}
              </>
            ) : (
              user?.email
            )}
          </div>
        </div>
      </div>

      <div className="py-1">
        <Link
          to="/profile-page"
          className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          onClick={onClose}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-3 text-textcolor"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            />
          </svg>
          View Profile
        </Link>

        <Link
          to="/edit-profile"
          className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          onClick={onClose}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-3 text-textcolor"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            />
          </svg>
          Edit Account Info
        </Link>

        <Link
          to="/profile-security"
          className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          onClick={onClose}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-3 text-textcolor"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          Manage Email & Password
        </Link>
      </div>

      <div className="py-1 border-t border-gray-200">
        <button
          onClick={handleLogout}
          className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-3 text-textcolor"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
          Log Out
        </button>
      </div>
    </div>
  );
}
